import { isEVMChain } from "@alephium/wormhole-sdk";
import { Button } from "@mui/material";
import { makeStyles } from 'tss-react/mui';
import detectEthereumProvider from "@metamask/detect-provider";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useEthereumProvider } from "@alephium/bridge-widget";
import {
  selectTransferSourceParsedTokenAccount,
  selectTransferTargetAsset,
  selectTransferTargetChain,
} from "../../store/selectors";
import { getEvmChainId } from "../../utils/consts";
import {
  evmTokenToParsedTokenAccount,
  getEthereumToken,
} from "../../utils/evm";

const useStyles = makeStyles()((theme) => ({
  addButton: {
    display: "block",
    margin: `${theme.spacing(1)} auto 0px`,
  },
}));

export default function AddToMetamask() {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const sourceParsedTokenAccount = useSelector(
    selectTransferSourceParsedTokenAccount
  );
  const targetChain = useSelector(selectTransferTargetChain);
  const targetAsset = useSelector(selectTransferTargetAsset);
  const {
    provider,
    signerAddress,
    chainId: evmChainId,
  } = useEthereumProvider();
  const hasCorrectEvmNetwork = evmChainId === getEvmChainId(targetChain);
  const handleClick = useCallback(() => {
    if (provider && targetAsset && signerAddress && hasCorrectEvmNetwork) {
      (async () => {
        try {
          const token = await getEthereumToken(targetAsset, provider);
          const { symbol, decimals } = await evmTokenToParsedTokenAccount(
            targetChain,
            token,
            signerAddress
          );
          const ethereum = (await detectEthereumProvider()) as any;
          ethereum.request({
            method: "wallet_watchAsset",
            params: {
              type: "ERC20", // In the future, other standards will be supported
              options: {
                address: targetAsset, // The address of the token contract
                symbol: (
                  symbol ||
                  sourceParsedTokenAccount?.symbol ||
                  "wh"
                ).substr(0, 5), // A ticker symbol or shorthand, up to 5 characters
                decimals, // The number of token decimals
                // image: string; // A string url of the token logo
              },
            },
          });
        } catch (e) {
          console.error(e);
        }
      })();
    }
  }, [
    provider,
    targetAsset,
    signerAddress,
    hasCorrectEvmNetwork,
    sourceParsedTokenAccount,
    targetChain
  ]);
  return provider &&
    signerAddress &&
    targetAsset &&
    isEVMChain(targetChain) &&
    hasCorrectEvmNetwork ? (
    <Button
      onClick={handleClick}
      size="small"
      variant="outlined"
      className={classes.addButton}
    >
      {t("Add to Metamask")}
    </Button>
  ) : null;
}
